import { FlagPredicate } from '../types';
import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { isFlagEnabled, isAnyFlagEnabled } from '../helpers';

export function useFlag(flag: string | FlagPredicate) {
  const flags = useContext(FlagContext);
  return isFlagEnabled(flags, flag);
}

export function useAnyFlag(flagSet: string[]) {
  const flags = useContext(FlagContext);
  return isAnyFlagEnabled(flags, flagSet);
}
